import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  public appVersion;
  public appInsightsKey;
  public enableDebug = true;
  public adClientId;

  public reportsEnabled: {
    po?: boolean;
    creativeServices?: boolean;
    ih?: boolean;
    popProduction?: boolean;
    thirdParty?: boolean;
    cardRanges?: boolean;
    production?: boolean;
  };

  public hideVersion: boolean;
  public hideSomeUIElements: boolean;
  public substituteEnabled: boolean;
  public emailTpsEnabled?: boolean;
}
